export default __webpack_public_path__ + "static/media/blog01.3f5df575.png";